import { Divider } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { ContentCopyRounded } from '@mui/icons-material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBan,
  faPenToSquare,
  faPhoneSlash,
  faRotateLeft,
  faVanShuttle,
  faTaxi
} from '@fortawesome/free-solid-svg-icons'

export default function UserDetailsCard({
  userInfo,
  created,
  lastLogin,
  onBlockUser,
  onUnblockUser,
  onComment,
  onDeletePhoneNumber,
  onSendWhatsApp,
  comment
}) {
  return (
    <div className='flex flex-col justify-center items-center gap-3 text-center w-full md:w-1/2 lg:w-[50%]'>
      <div className='flex flex-col justify-center items-center gap-4 text-center border-[1px] border-gray rounded-lg p-5 w-full relative dark:border-dk-border'>
        <img
          className='rounded-full mt-3 w-[150px] h-[150px]'
          width='150'
          height='150'
          src={userInfo.picture}
          alt='User profile'
        />
        <div className='flex flex-col gap-2 items-center w-full'>
          <div className='flex items-center gap-2 w-full justify-center'>
            <p className='font-bold text-base truncate max-w-[80%]' title={userInfo.user_id}>
              {userInfo.user_id}
            </p>
            <ContentCopyRounded
              className='cursor-pointer hover:opacity-50 text-[#d65944]'
              onClick={() => navigator.clipboard.writeText(userInfo.user_id)}
            />
          </div>
          <button
            onClick={() => {
              window.open(
                `https://mixpanel.com/project/2806693/view/3341141/app/profile#distinct_id=${userInfo.user_id}`,
                '_blank'
              )
            }}
            className='bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors'
          >
            Abrir en Mixpanel
          </button>
        </div>
        <Divider sx={{ width: '100%' }} />
        <div
          className='flex flex-row items-center m-auto cursor-pointer'
          onClick={() =>
            onSendWhatsApp
              ? onSendWhatsApp()
              : window.open(
                  `https://api.whatsapp.com/send/?phone=${userInfo.user_metadata.phone_number}&text=%20`
                )
          }
        >
          <WhatsAppIcon className='cursor-pointer text-green-600 dark:text-emerald-400' />
          <p className='font-bold ml-1'>{userInfo.user_metadata.phone_number}</p>
          <ContentCopyRounded
            className='cursor-pointer hover:opacity-50 text-[#d65944] ml-2'
            onClick={e => {
              e.stopPropagation()
              navigator.clipboard.writeText(userInfo.user_metadata.phone_number)
            }}
          />
        </div>

        <Divider sx={{ width: '100%' }} />
        <div className='flex items-center gap-2 justify-center w-full'>
          <p
            className='truncate max-w-[80%]'
            title={userInfo.email || userInfo.user_metadata.email}
          >
            {userInfo.email || userInfo.user_metadata.email}
          </p>
          <ContentCopyRounded
            className='cursor-pointer hover:opacity-50 text-[#d65944]'
            onClick={() =>
              navigator.clipboard.writeText(userInfo.email || userInfo.user_metadata.email || '')
            }
          />
        </div>
        {(userInfo.user_metadata.operator === 'van' ||
          userInfo.user_metadata.operator === 'taxi') && (
          <>
            <Divider sx={{ width: '100%' }} />
            <div className='flex items-center gap-2'>
              <FontAwesomeIcon
                icon={userInfo.user_metadata.operator === 'van' ? faVanShuttle : faTaxi}
                style={{ color: '#FDB813', fontSize: '1.25rem' }}
              />
              <span style={{ color: '#FDB813' }} className='font-medium text-base'>
                Chofer
              </span>
            </div>
          </>
        )}
        {onDeletePhoneNumber && (
          <div className='absolute top-6 right-16 cursor-pointer' onClick={onDeletePhoneNumber}>
            <FontAwesomeIcon icon={faPhoneSlash} className='text-primary w-6 h-6' />
          </div>
        )}
        {onUnblockUser && userInfo.blocked && (
          <div className='absolute top-6 right-6 cursor-pointer' onClick={onUnblockUser}>
            <FontAwesomeIcon icon={faRotateLeft} className='text-primary w-6 h-6' />
          </div>
        )}
        {onBlockUser && !userInfo.blocked && (
          <div className='absolute top-6 right-6 cursor-pointer' onClick={onBlockUser}>
            <FontAwesomeIcon icon={faBan} className='text-primary w-6 h-6' />
          </div>
        )}
      </div>
      <div className='flex flex-col justify-center items-center gap-3 text-center border-[1px] border-gray rounded-lg p-5 w-full dark:border-dk-border'>
        {userInfo?.user_metadata?.verified === 'pending' ? (
          <p className='text-center text-primary'>Usuario pendiente de verificación</p>
        ) : (
          userInfo?.user_metadata.verified === true && (
            <p className='font-bold'>Usuario Verificado</p>
          )
        )}
        {userInfo.blocked && <p className='text-center font-bold text-error'>Usuario bloqueado</p>}
        <p>
          <span className='font-bold'>Registrado: </span>
          {created
            ? `${created.dayName} ${created.day} de ${created.monthName} ${created.year} ${created.time}`
            : 'Sin datos'}
        </p>
        <p>
          <span className='font-bold'>Último ingreso: </span>
          {lastLogin
            ? `${lastLogin.dayName} ${lastLogin.day} de ${lastLogin.monthName} ${lastLogin.year} ${lastLogin.time}`
            : 'Sin datos'}
        </p>
        <div className={onComment ? 'cursor-pointer' : ''} onClick={onComment || undefined}>
          <p className='font-bold text-center mb-2'>
            Comentario {onComment && <FontAwesomeIcon icon={faPenToSquare} className='text-primary' />}
          </p>
          <p className='text-start'>
            {comment === '' ? (
              <span className='text-gray dark:text-gray-400'>No hay comentario</span>
            ) : (
              comment.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))
            )}
          </p>
        </div>
      </div>
    </div>
  )
}
